module.exports = __webpack_public_path__ + "media/images/sp/page_common/keywords/keyword_wayo-b4852c8e1f3faf1b0bea143ac6bc7afe.jpg";